import { EditPropertyContextWrapper } from "../components/properties/EditPropertyContext"
import PropertiesSidebar from "../components/properties/PropertiesSidebar"
import PropertyDetailView from "../components/properties/PropertyDetailView"
import { NavigationService } from "../services/navigationService"

type Props = {
  googleMapsApiKey: string
  customerId?: number
  navigationService: NavigationService
  showDeletedView: boolean
}

const PropertiesPage = ({googleMapsApiKey, customerId, navigationService, showDeletedView}: Props) => {
  const getInitialPropertyId = () => {
    const hash = navigationService.hash
    if (hash === 'new') {
      return 0
    }
    const pId = hash?.match(/\d+/)
    if (pId && pId.length > 0) {
      return parseInt(pId[0])
    }
  }
  const initialPropertyId = getInitialPropertyId()

  return <EditPropertyContextWrapper
    googleMapsApiKey={googleMapsApiKey}
    customerId={customerId}
    initialPropertyId={initialPropertyId}
    onPropertyChange={propertyId => navigationService.setHash(propertyId === undefined ? '' : `${propertyId}`)}
    showDeletedView={showDeletedView}
  >
    <PropertiesSidebar />
    <PropertyDetailView />
  </EditPropertyContextWrapper>
}

export default PropertiesPage
